import React, {Component} from "react";
import { Helmet } from "react-helmet";
import { GlamPointsHistory } from "../../components/glamclub/GlamPointsHistory";
import { GetGlampointsAndBadge } from "../../components/glamclub/GetGlampointsAndBadge";
import { GlamboxEndpoints } from "../../core/glambox/GlamboxEndpoints";
import { ExecuteRequest } from "../../core/glambox/GlamboxApi";
import { connect } from "react-redux";

export class GlamPoints extends Component{
  constructor(props){
    super(props);

    this.state = {
      rewardData: []
    }

    this.getGlampointsCreditHistory = this.getGlampointsCreditHistory.bind(this);
  }

  componentDidMount(){
    this.setState({ rewardData: this.props.rewards });
  }

  getGlampointsCreditHistory(){
    ExecuteRequest(
        GlamboxEndpoints.Person.reward,
        null,
        "GET",
        {
          Authorization: this.props.token.Authorization
        },
        null,
        (response) => {
          let {
            result,
            statusCode
          } = response;

           if(statusCode === 200){
             this.setState({rewardData: result});
           }               
       } 
    )
  }

  render(){
    if (this.state.rewardData.length < 1) {
      return (
        <div className={"p-2 p-lg-5"}>  
          <Helmet>
            <title>Minha Glambox : Glampoints</title>
          </Helmet>
      
          <h1>Saldo de Glampoints</h1>
  
          <div className={"p-2 p-lg-5 text-center"}>
            <p className={"lead text-muted"}>Você ainda não possui saldo de Glampoints.</p>
          </div>
        </div>
      );
    }

    return (
      <div className={"p-2 p-lg-5 glampoints_page"}>         
        <Helmet>
          <title>Minha Glambox : Glampoints</title>
        </Helmet>
      
        <h1>Saldo de Glampoints</h1>

        <GetGlampointsAndBadge rewardInfo={this.state.rewardData} person={this.props.person}></GetGlampointsAndBadge>
        
        <GlamPointsHistory rewardInfo={this.state.rewardData}></GlamPointsHistory>
      </div>
    );
  }
}

const mapStateToProps = (state) =>{
  return {
    token: state.token.data,
    rewards: state.rewards.data,
    person: state.person.data
  }
}

GlamPoints = connect(mapStateToProps)(GlamPoints);
